import { useState, useEffect, useRef } from "react";
import auraBgList from "./Backgrounds";
import { formatNumber, getItemByName, getRandomNumber } from "./Functions";
import { UpgradeItem } from "./UpgradeItem";
import uEmoji from "./UpgraderEmotions";
import ConfirmMessage from "./ConfirmMessage";
import { Player } from "@lottiefiles/react-lottie-player";
import HealthIcon from "./Icons/HealthIcon";
import SpeedIcon from "./Icons/SpeedIcon";
import DamageIcon from "./Icons/DamageIcon";
import BpIcon from "./Icons/BpIcon";
import useToast from "./Toast/useToast";
import ToastNotification from "./Toast/ToastNotification";
import { color } from "framer-motion";
import { useSocket } from "./SocketContext";

export const UpgradeWindow = ({
  activeItem,
  setUpgradeWindow,
  handleAurasUpdate,
  socket,
  localProfile,
  motion,
  t,
  auraStats,
}) => {
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [upgradingAnim, setUpgradingAnim] = useState("");

  const [showInstruction, setShowInstruction] = useState(false);

  const { toasts, addToast } = useToast();

  const handleConfirmUpgrading = async () => {
    processUpgrade(activeItem);
    setIsConfirmOpen(false);
  };

  const handleCancelUpgrading = () => {
    setIsConfirmOpen(false);
  };

  const [processOpacity, setProcessOpacity] = useState(1);

  const [upgraderText, setUpgraderText] = useState(t("Upgrader"));
  const [upgraderImg, setUpgraderImg] = useState(uEmoji.hi1);
  const [upgraderStyle, setUpgraderStyle] = useState("font-2p");
  const emojiTaps = useRef(0);

  const [percent, setPercent] = useState(0);
  const { emit, on, off, once, isConnected } = useSocket();

  const processUpgrade = (aura) => {
    if (!scroll) {
      addToast(t("No upgrade scrolls"), "error");
      setUpgraderImg(uEmoji.why);
      setUpgraderText(t("no scroll"));
      return;
    }
    if (aura.auraLvl >= 24) {
      setUpgraderImg(uEmoji.wow);
      setUpgraderText(t("+24 already"));
      return;
    }
    setUpgraderImg(uEmoji.wait2);
    setUpgraderText(t("Upgrading..."));
    setPercent(102);
    setIsButtonActive(false);
    setUpgradingAnim("upgrading-img-anim");
    setTimeout(() => {
      setUpgradingAnim("");
      startUpgrade(aura);
      setProcessOpacity(0);
      setPercent(0);

      setTimeout(() => {
        setUpgraderStyle("font-2p");
        setIsButtonActive(true);
        setProcessOpacity(1);
      }, 3000);
    }, 3000);
  };

  const [isButtonActive, setIsButtonActive] = useState(true);

  const [itemsData, setItemsData] = useState({});

  useEffect(() => {
    const fetchItemsData = async () => {
      // Фильтруем элементы по нужным типам
      const filteredItems = localProfile.ItemsList.filter(
        (item) =>
          item.type === "upgrade-scroll" ||
          item.type === "upgrade-protect" ||
          item.type === "upgrade-luck"
      );

      // Создаем массив промисов для получения информации о каждом элементе
      const promises = filteredItems.map(async (item) => {
        const itemInfo = await getItemByName(item.title);
        return { ...item, itemInfo };
      });

      // Ожидаем завершения всех промисов
      const itemsWithData = await Promise.all(promises);

      // Обновляем itemsData
      setItemsData(itemsWithData);

      // Проверяем, есть ли элементы с такими же id, как в текущих состояниях
      let foundLuckyPotion = false;
      let foundProtectPotion = false;
      let foundScroll = false;

      itemsWithData.forEach((item) => {
        if (luckyPotion && item.id === luckyPotion.id) {
          setLuckyPotion(item); // Обновляем luckyPotion
          foundLuckyPotion = true;
        }
        if (protectPotion && item.id === protectPotion.id) {
          setProtectPotion(item); // Обновляем protectPotion
          foundProtectPotion = true;
        }
        if (scroll && item.id === scroll.id) {
          setScroll(item); // Обновляем scroll
          foundScroll = true;
        }
      });

      // Если элемент не найден, сбрасываем состояние
      if (!foundLuckyPotion) {
        setLuckyPotion(null); // или setLuckyPotion(undefined)
      }
      if (!foundProtectPotion) {
        setProtectPotion(null); // или setProtectPotion(undefined)
      }
      if (!foundScroll) {
        setScroll(null); // или setScroll(undefined)
      }

      console.log(itemsWithData);
    };

    if (localProfile.ItemsList) {
      fetchItemsData();
    }
  }, [localProfile.ItemsList]);

  const [openItems, setOpenItems] = useState(null);

  const openItemsClick = (num) => {
    if (openItems === num) {
      setOpenItems(null);
    } else {
      setOpenItems(num);
    }
  };

  const [luckyPotion, setLuckyPotion] = useState();
  const [protectPotion, setProtectPotion] = useState();
  const [scroll, setScroll] = useState();

  useEffect(() => {
    const itemz = () => {
      console.log("LSP: ", scroll, luckyPotion, protectPotion);
    };
    itemz();
  }, [itemsData]);

  const [baseProbability, setBaseProbability] = useState(
    100 - activeItem.auraLvl * 4
  );

  useEffect(() => {
    const calcProbability = () => {
      let currentProb = 100 - activeItem.auraLvl * 4;

      if (luckyPotion) {
        currentProb += 10;
      }
      if (currentProb > 100) {
        currentProb = 100;
      }
      setBaseProbability(currentProb);
    };
    calcProbability();
  }, [luckyPotion, activeItem]);

  const startUpgrade = async (aura) => {
    const oldAuraLvl = aura.auraLvl;

    let hasProtectPotion = false;
    // Проверяем наличие Protect Potion для защиты от полного сброса уровня
    if (protectPotion) {
      hasProtectPotion = true;
    }

    // Определяем, на сколько увеличить уровень
    let upgradeAmount = 1;
    if (scroll.title === "Upgrade scroll +1-3") {
      upgradeAmount = Math.floor(Math.random() * 3) + 1; // Случайное число от 1 до 3
    }

    // Симуляция улучшения
    const dice = Math.random() * 100;
    const isSuccess = dice < baseProbability;
    console.log("УДАЧА:", baseProbability);
    console.log("ВЫПАЛО:", dice);
    let removeProtectPotion = true;

    let newBackground = aura.auraBg;
    if (isSuccess) {
      setUpgraderStyle("font-2p upgrade-success-window");
      // Успешное улучшение
      let newAuraLvl = aura.auraLvl + upgradeAmount;
      if (newAuraLvl > 24) {
        newAuraLvl = 24;
      }

      if (oldAuraLvl < 6 && newAuraLvl >= 6) {
        const randomBg = getRandomNumber(0, 6);
        newBackground = randomBg;
      }
      if (oldAuraLvl < 17 && newAuraLvl >= 17) {
        const randomBg = getRandomNumber(7, 27);
        newBackground = randomBg;
      }
      setUpgraderImg(uEmoji.yes1);
      setUpgraderText(t("Lucky!") + " +" + newAuraLvl);
      aura.auraLvl = newAuraLvl;
      console.log(`Успешное улучшение! Новый уровень: ${aura.auraLvl}`);
      removeProtectPotion = false;
    } else {
      setUpgraderStyle("font-2p upgrade-broken-window");
      // Неудачное улучшение
      if (hasProtectPotion) {
        // Если есть Protect Potion, уровень понижается на 1-3

        const downgradeAmount = Math.floor(Math.random() * 3);
        const newAuraLvl = Math.max(aura.auraLvl - downgradeAmount, 0);

        if (newAuraLvl < 6) {
          newBackground = null;
        } else if (oldAuraLvl >= 17 && newAuraLvl < 17) {
          const randomBg = getRandomNumber(0, 6);
          newBackground = randomBg;
        }

        setUpgraderImg(uEmoji.no1);
        setUpgraderText(t("Broken!") + " +" + newAuraLvl);
        aura.auraLvl = newAuraLvl;
        console.log(
          `Неудачное улучшение, но Protect Potion защитил! Уровень понижен на ${downgradeAmount}. Новый уровень: ${aura.auraLvl}`
        );
      } else {
        // Если нет Protect Potion, уровень сбрасывается до 0
        aura.auraLvl = 0;
        newBackground = null;
        setUpgraderImg(uEmoji.no2);
        setUpgraderText(t("Broken! Lvl has been reset"));
        console.log("Неудачное улучшение! Уровень сброшен до 0.");
      }
    }

    // Обновляем данные на сервере
    emit("itemsUpdate", {
      playerId: localProfile.id,
      itemsToUse: [
        { title: scroll.title }, // Добавляем scroll всегда
        luckyPotion ? { title: luckyPotion.title } : null, // Добавляем luckyPotion, если он есть
        protectPotion && removeProtectPotion
          ? { title: protectPotion.title }
          : null, // Добавляем protectPotion, если он есть и removeProtectPotion true
      ].filter((item) => item !== null), // Убираем все null значения из массива
      action: "remove",
    });

    once("itemsUpdateSuccess", async (itemsList) => {
      await handleAurasUpdate(
        {
          title: aura.title,
          probability: aura.probability,
          quantity: 0,
          auraLvl: aura.auraLvl,
          auraBg: newBackground,
        },
        null
      );
    });
  };
  function getRandomEmoji(emojiObj) {
    const keys = Object.keys(emojiObj); // Получаем массив ключей
    const randomKey = keys[Math.floor(Math.random() * keys.length)]; // Выбираем случайный ключ
    return emojiObj[randomKey]; // Возвращаем значение по случайному ключу
  }
  const tapUpgrader = () => {
    emojiTaps.current += 1;
    console.log(emojiTaps.current);
    if (emojiTaps.current > 10) {
      setUpgraderImg(getRandomEmoji(uEmoji));
      emojiTaps.current = 0;
    }
  };

  return (
    <>
      {isConfirmOpen && (
        <ConfirmMessage
          message={t(
            "Upgrading without a Protect Potion will reset the level to 0 if you fail, are you sure?"
          )}
          onConfirm={handleConfirmUpgrading}
          onCancel={handleCancelUpgrading}
        />
      )}
      {showInstruction && (
        <div className="instruction-wrapper">
          <div className="instruction-text">
            {t(
              "To improve the aura, you need at least a Upgrade Scroll (slot 3), which can be found in dungeons. If the enhancement fails, the enhancement level resets, but with a Upgrade Protect potion (slot 2), the level will only drop by 0-2 points. A Upgrade Luck potion(slot 1) increases the enhancement success rate. The maximum enhancement level is +24. At +6, the background changes, and at +17, it switches to a more interesting one, which can later be customized for DUCK$."
            )}
          </div>
          <motion.button
            whileTap={{ scale: 0.97 }}
            transition={{ duration: 0.1 }}
            onClick={() => setShowInstruction(false)}
            style={{
              width: "80%",
              backgroundColor: "rgb(0, 0, 0)",
              color: "white",
            }}
            className="upgrade-buttons"
          >
            {t("Back")}
          </motion.button>
        </div>
      )}
      <div
        className="upgrade-window"
        style={{
          position: "absolute",
          backgroundColor: "#272727",
          zIndex: 7,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          width: "97%",
          padding: "10px",
          borderRadius: 12,
          maxWidth: 500,
        }}
      >
        <motion.button
          whileTap={{ scale: 0.97 }}
          transition={{ duration: 0.1 }}
          onClick={() => setShowInstruction(true)}
          className="info-button"
        >
          {t("Info")}
        </motion.button>
        <div style={{ width: "100%", display: "flex", gap: 10 }}>
          <div
            style={{
              backgroundColor: "black",
              width: 76,
              height: 76,
              aspectRatio: "1/1",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: 8,
            }}
          >
            <motion.img
              whileTap={{ scale: 0.9 }}
              transition={{ duration: 0.05 }}
              onTap={() => tapUpgrader()}
              width={60}
              src={upgraderImg}
            ></motion.img>
          </div>
          <div
            className={upgraderStyle}
            style={{
              fontSize: 12,
              color: "#fff000",
              backgroundColor: "black",
              borderRadius: 8,
              width: "100%",
              height: 76,
              padding: 10,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: 10,
            }}
          >
            {upgraderText}
          </div>
        </div>
        <div
          className="upgrade-background"
          style={{
            position: "relative",
            backgroundColor: activeItem.color,
            paddingTop: 40,
            backgroundImage:
              activeItem.auraBg != null
                ? `url(${auraBgList[activeItem.auraBg].auraBg})`
                : "",
          }}
        >
          <div
            style={{
              position: "absolute",
              left: 0,
              top: 0,
              width: "100%",
              display: "flex",
              justifyContent: "center",
              zIndex: 8,
            }}
          >
            <div
              style={{
                position: "relative",
                display: "flex",
                gap: 16,

                justifyContent: "space-around",
                backgroundColor: "rgb(0, 0, 0)",
                padding: "6px 20px",
                borderRadius: "0px 0px 30px 30px",
                fontSize: 12,
              }}
            >
              <div style={{ display: "flex", gap: 5, alignItems: "center" }}>
                <HealthIcon size="12px" fill="red" />
                <div>{formatNumber(auraStats?.hp)}</div>
              </div>
              <div style={{ display: "flex", gap: 5, alignItems: "center" }}>
                <SpeedIcon size="12px" fill="green" />
                <div>{formatNumber(auraStats?.speed)}/sec</div>
              </div>
              <div style={{ display: "flex", gap: 5, alignItems: "center" }}>
                <DamageIcon size="12px" fill="orange" />
                <div>{formatNumber(auraStats?.damage)}</div>
              </div>
              <div style={{ display: "flex", gap: 5, alignItems: "center" }}>
                <BpIcon size="12px" fill="yellow" />
                <div>{formatNumber(auraStats?.bp)}</div>
              </div>
            </div>
          </div>
          {upgradingAnim && (
            <div
              style={{
                position: "absolute",
                height: "100%",
                width: "100%",
                display: "flex",
                alignItems: "center",
                top: 0,
                left: 0,
              }}
            >
              <Player
                autoplay
                loop
                src="upgrading.json"
                style={{
                  position: "relative",
                  width: "100%",
                  opacity: 0.8,
                }}
              ></Player>
            </div>
          )}

          {activeItem?.webm ? (
            <video
              className={upgradingAnim}
              width={"50%"}
              src={activeItem.img}
              alt="active-item"
              autoPlay
              loop
              muted
            />
          ) : (
            <img
              className={upgradingAnim}
              width={"50%"}
              src={activeItem.img}
              alt="active-item"
            />
          )}
          <div
            className="font-2p"
            style={{
              backgroundColor: "black",
              color: activeItem.color,
              padding: "8px 8px",
              textAlign: "center",
              borderRadius: 4,
            }}
          >
            {t(activeItem.title)}
            {activeItem.auraLvl > 0 && " +" + activeItem.auraLvl}
          </div>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            padding: "5px 8px",
            marginBottom: 50,
            marginTop: 8,
          }}
        >
          <div className="upgrading-line-bg">
            <div
              style={{
                transform: `translateX(${-102 + percent}%)`,
                opacity: processOpacity,
              }}
              className="upgrading-line"
            ></div>
          </div>
        </div>
        <div
          style={{
            width: "94%",
            position: "absolute",
            bottom: -40,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "75%",
            }}
          >
            <UpgradeItem
              isButtonActive={isButtonActive}
              choosenItem={luckyPotion}
              itemsData={itemsData}
              setActiveItem={(item) => setLuckyPotion(item)}
              setOpenItems={setOpenItems}
              openItemsClick={openItemsClick}
              openItems={openItems}
              itemType="upgrade-luck"
              greyImage="upgrade-images/120px/luck-upgrade-bg.webp"
              itemNumber={1}
            ></UpgradeItem>
            <UpgradeItem
              isButtonActive={isButtonActive}
              choosenItem={protectPotion}
              itemsData={itemsData}
              setActiveItem={(item) => setProtectPotion(item)}
              setOpenItems={setOpenItems}
              openItemsClick={openItemsClick}
              openItems={openItems}
              itemType="upgrade-protect"
              greyImage="upgrade-images/120px/protect-upgrade-bg.webp"
              itemNumber={2}
            ></UpgradeItem>
            <UpgradeItem
              isButtonActive={isButtonActive}
              choosenItem={scroll}
              itemsData={itemsData}
              setActiveItem={(item) => setScroll(item)}
              setOpenItems={setOpenItems}
              openItemsClick={openItemsClick}
              openItems={openItems}
              itemType="upgrade-scroll"
              greyImage="upgrade-images/120px/scroll-bg.webp"
              itemNumber={3}
            ></UpgradeItem>
          </div>
        </div>
      </div>

      <div
        className="upgrade-buttons-container"
        style={{
          position: "absolute",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: 10,
          bottom: 20,
          zIndex: 7,
          width: "97vw",
          maxWidth: 500,
        }}
      >
        <motion.button
          whileTap={{ scale: 0.97 }}
          transition={{ duration: 0.1 }}
          disabled={!isButtonActive || !scroll}
          onClick={() =>
            protectPotion
              ? processUpgrade(activeItem)
              : activeItem.auraLvl > 0
              ? setIsConfirmOpen(true)
              : processUpgrade(activeItem)
          }
          style={{ width: "80%" }}
          className="upgrade-buttons"
        >
          {t("Upgrade")}
        </motion.button>
        <motion.button
          whileTap={{ scale: 0.97 }}
          transition={{ duration: 0.1 }}
          style={{ backgroundColor: "#757575", width: "80%" }}
          className="upgrade-buttons"
          onClick={() => {
            if (isButtonActive) {
              setUpgradeWindow(false);
            }
          }}
        >
          {t("Back")}
        </motion.button>
      </div>
      <ToastNotification toasts={toasts} />
      <div
        onClick={() => {
          if (openItems !== null) {
            setOpenItems(null);
          } else {
            if (isButtonActive) {
              setUpgradeWindow(false);
            }
          }
        }}
        className="black-screen"
        style={{ backgroundColor: "rgba(0,0,0,0.95)", zIndex: 6 }}
      ></div>
    </>
  );
};
